// Inicialização opcional do Sentry no frontend. Sem VITE_SENTRY_DSN
// não faz nada (dev e builds sem observabilidade continuam iguais).
// Ver docs/plans/endurecimento-producao-qa.md (4.2).

import * as Sentry from '@sentry/react';

export function initSentry({
  dsn = import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  environment = import.meta.env.MODE,
} = {}) {
  if (!dsn) return false;
  const rate = parseFloat(tracesSampleRate || '0');
  Sentry.init({
    dsn,
    integrations: rate > 0 ? [Sentry.browserTracingIntegration()] : [],
    tracesSampleRate: rate,
    environment,
  });
  return true;
}
